import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CSSTransition, SwitchTransition } from 'react-transition-group'

import { appendOnboarding } from '../../../../features/session/sessionSlice'
import { appendModel } from '../../../../features/site/siteSlice'
import { serviceMap } from '../../../utils/common'
import ServiceCard from '../../Admin/ServiceTypes/ServiceCard'
import FacebookAds from '../Services/PaidAds/FacebookAds'
import LinkedInAds from '../Services/PaidAds/LinkedInAds'
import MicrosoftAds from '../Services/PaidAds/MicrosoftAds'
import SummaryCard from '../Services/PaidAds/SummaryCard'

const PAID_ADS = ["bing", "fb", "linkedin"]

function PaidAds(){
    const dispatch = useDispatch()

    const state = useSelector(state => state.session.onboarding)
    const model = useSelector(state => state.site.model)
    
    const nextEnabled = (state.dontHaveIt.fb || model.siteForm?.attr?.accounts?.fb) &&
        (state.dontHaveIt.bing || model.siteForm?.attr?.accounts?.bing) &&
        (state.dontHaveIt.linkedin || model.siteForm?.attr?.accounts?.linkedin)

    const unsetService = async(service) => {
        await dispatch(appendModel({
            siteForm: {
                ...model.siteForm,
                attr: {
                    ...model.siteForm.attr,
                    accounts: {
                        ...(model.siteForm?.attr?.accounts ?? {}),
                        [service]: undefined
                    }
                }
            }
        }))

        localStorage.removeItem(`${service}Selection`)
    }

    const { paidAdsService, animationClass } = state
    const { siteForm } = model

    const summaryEnabled = (service) => PAID_ADS.reduce((prev, curr) => {
        if(!state.dontHaveIt[curr] && (!model.siteForm?.attr?.accounts || !model.siteForm?.attr?.accounts[curr]) && curr !== service){
            prev = false
        }

        return prev
    }, true)

    const onAction = (service, nextService, dontHaveIt=false) => {
        dispatch(appendOnboarding({
            dontHaveIt: {
                ...state.dontHaveIt,
                [service]: dontHaveIt
            },
            animationClass: "service-selection",
            paidAdsService:  nextEnabled || summaryEnabled(service) ? "summary" : nextService
        }))
        if(dontHaveIt){
            unsetService(service)
        }
    }

    return <>
        <div class="d-flex justify-content-center align-items-center flex-sm-row flex-column">
            <SwitchTransition mode={"out-in"}>
                <CSSTransition
                    key={paidAdsService}
                    addEndListener={(node, done) => {
                        node.addEventListener("transitionend", done, false);
                    }}
                    classNames={animationClass}>
                    <div className="service-container">
                        {paidAdsService === "bing" && <MicrosoftAds 
                            onSave={(service) => onAction(service, "fb")} 
                            onCancel={(service) => onAction(service, "fb", true)} />}
                        {paidAdsService === "fb" && <FacebookAds 
                            onSave={(service) => onAction(service, "linkedin")} 
                            onCancel={(service) => onAction(service, "linkedin", true)} />}
                        {paidAdsService === "linkedin" && <LinkedInAds 
                            onSave={(service) => onAction(service, "bing")} 
                            onCancel={(service) => onAction(service, "bing", true)} />}
                        {paidAdsService === "summary" && <SummaryCard />}
                    </div>
                </CSSTransition>
            </SwitchTransition>
            <div className="ml-4 d-none d-sm-block">
                {Object.values(serviceMap).filter(s => PAID_ADS.includes(s.key)).map(service => <div style={{width: "100px"}} className="text-center mb-4">
                    <ServiceCard 
                        {...service} 
                        active={paidAdsService === service.key}
                        onChosen={() => dispatch(appendOnboarding({
                            animationClass: "service-selection-r",
                            paidAdsService: service.key
                        }))} 
                        overrideIcon={state?.dontHaveIt[service.key] ? <i class="fas fa-minus-circle text-warning fa-1-5"></i> : siteForm?.attr?.accounts && siteForm?.attr?.accounts[service.key] ? <i class="fas fa-check-circle text-success fa-1-5"></i> : null}
                    />
                </div>)}
            </div>
        </div>
        <div className="d-flex justify-content-between d-sm-none align-items-stretch">
            {Object.values(serviceMap).filter(s => PAID_ADS.includes(s.key)).map(service => <div style={{width: "100px"}}>
                <ServiceCard 
                    {...service} 
                    active={paidAdsService === service.key}
                    onChosen={() => dispatch(appendOnboarding({
                        animationClass: "service-selection-r",
                        paidAdsService: service.key
                    }))} 
                    overrideIcon={state?.dontHaveIt[service.key] ? <i class="fas fa-minus-circle text-warning fa-1-5"></i> : siteForm?.attr?.accounts && siteForm?.attr?.accounts[service.key] ? <i class="fas fa-check-circle text-success fa-1-5"></i> : null}
                />
            </div>)}
        </div>
    </>
}

export default PaidAds